import * as React from 'react';
import { bookingCols, CBLCols, EquipmentCols, FCRCols, SEARCH_TABS_RESULT } from './models';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { GeneralTable } from 'modules/search/components/GeneralTable';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
interface ITableresult {
    result: any;
    booking: any,
    fcr: any,
    equipment: any,
    cbl: any,
    totalCount: number
}
interface IProps {
    fetchApi: (tableData: any, status: any) => void;
    fetchLoading: boolean
    data: ITableresult
    pageSize: number;
    activeTab: number;
    callbackTab: (e: number) => void;
    targetResult: boolean;
    linkAction: (e: string) => void;
    refFwd?: any;
    featureToggles: IFeatureToggleModel[];
}
export const SearchResults: React.FunctionComponent<IProps> = (props) => {
    const tabRef: any = React.createRef();
    const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, props.featureToggles);
    const getTable = (cols: any, data: any, tableName: string) => {
        if (isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, props.featureToggles) && tableName === 'jobCosting-search-fcr') {
            if (cols !== null) {
                cols = cols.map((item: any) => {
                    if (item.accessor === 'documentNumber') {
                        item.fieldHeader = 'Document number';
                    }
                    return item;
                });
            }
        }
        const newData = [...data];
        newData.map((item: any) => {
            if (item.clrNumber && item.documentNumber && item.documentNumber.indexOf('/') === -1) {
                item.documentNumber = `${item.documentNumber}/${item.clrNumber}`
            }
            else if (isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, props.featureToggles)) {
                if (item.number && item.documentNumber && item.documentNumber.indexOf('/') === -1) {
                    item.documentNumber = `${item.documentNumber}/${item.number}`
                }
            }
        })
        return <GeneralTable
            id={tableName}
            cols={cols}
            data={newData}
            isLoading={props.fetchLoading}
            fetchData={props.fetchApi}
            linkAction={(e: any) => linkCheck(e)}
            refFwd={props.refFwd}
            pageCount={Math.ceil(props.data.totalCount / props.pageSize)}
        />
    }
    const linkCheck = (e: any) => {
        let url = '';
        switch (e.documentType) {
            case 'Booking':
                url = `/job-costing/booking/${e.id}`
                break;
            case 'FCR':
                url = `/job-costing/documents/${e.id}`;
                break;
            case 'CBL':
                url = `/job-costing/cbls/${e.id}`
                break;
            case 'EquipmentClr':
                url = `/job-costing/equipments/${e.id}`;
                break;
        }
        props.linkAction(url)
    }
    return (
        <div>
            <h3 className="title-blue-underline padding-top-large">Search results</h3>
            <TabComponent name="search-results" activeTab={props.activeTab - 1} callbackFc={(e: number) => {
                const checks = tabRef.current.querySelectorAll('.dam-tabs-horizontal > span')
                if (checks && checks.length > 0 && checks[e - 1]) {
                    checks.forEach((element: any, index: number) => {
                        if (index === e - 1) {
                            element.querySelector('input').classList.add('selected')
                        } else {
                            element.querySelector('input').classList.remove('selected')
                        }
                    });
                }
                checks.check = true;
                props.callbackTab(e)
            }} navLinks={SEARCH_TABS_RESULT(isHblConsumptionEnabled)} fRef={tabRef}>
                {getTable(null, props.data.result, 'jobCosting-search-general')}
                {getTable(bookingCols, props.data.booking, 'jobCosting-search-booking')}
                {getTable(FCRCols(isHblConsumptionEnabled), props.data.fcr, 'jobCosting-search-fcr')}
                {getTable(CBLCols, props.data.cbl, 'jobCosting-search-cbl')}
                {getTable(EquipmentCols, props.data.equipment, 'jobCosting-search-equipments')}
            </TabComponent>
        </div>
    );
}